import React from 'react'

export const M = ({ children }: { children: any }) => {
  return <span className='marker'>{children}</span>
}

